import { Component, OnInit } from "@angular/core";
import { E } from "@angular/core/src/render3";

@Component({
  selector: "app-home-page",
  templateUrl: "./home-page.component.html",
  styleUrls: ["./home-page.component.scss"],
})
export class HomePageComponent implements OnInit {
  page: number = 1;
  selectedList: any;
  stepOneOption: any;
  stepOneDone: boolean;
  constructor() {}

  ngOnInit() {}

  togglepage(data) {
    console.log(data);
  }
  nextStep() {
    this.page += 1;
  }
  previousPage() {
    this.page -= 1;
  }

  toggleStep(event) {
    console.log(event);
    switch (event.step) {
      case "1":
        console.log("step 1");
        if (event.nextStep) {
          this.selectedList = event.selectedList;
          this.stepOneOption = event.optionType;
          this.stepOneDone = true;
        } else {
          this.selectedList = null;
          this.stepOneOption = null;
          this.stepOneDone = false;
        }
        this.isDisabled();
        break;
      case "2":
        console.log("step 1");
        break;
      case "3":
        console.log("step 1");
        break;
      case "4":
        console.log("step 1");
        break;
    }
  }

  isDisabled() {
    console.log(
      "checking",
      this.page == 1 && !!this.selectedList && !!this.stepOneOption
    );

    let disabled = true;
    if (this.page == 1 && !!this.selectedList && !!this.stepOneOption) {
      disabled = false;
    } else if (this.page == 2 && this.selectedList && this.stepOneOption) {
      // disabled = ftalse;
    } else if (this.page == 3 && this.selectedList && this.stepOneOption) {
      // disabled = false;
    } else if (this.page == 4 && this.selectedList && this.stepOneOption) {
      // disabled = false;
    }
    return disabled;
  }
}
